import { Yii } from 'libraries/interfaces/Yii';
import { ILabels } from 'libraries/interfaces/ILabels';

export const MENU_ITEMS_LABELS: ILabels = {
    sectors: Yii.t('wui-shared-js', 'Étapes'),
    travellers: Yii.t('wui-shared-js', 'Voyageurs'),
    contacts: Yii.t('wui-shared-js', "Contacts"),
    pricing: Yii.t('wui-shared-js', "Tarifications"),
    specialsServices: Yii.t('wui-shared-js', 'Services Spéciaux'),
    remarks: Yii.t('wui-shared-js', 'Remarques'),
    identification: Yii.t('wui-shared-js', "Identification"),
    bookingOperations: Yii.t('wui-shared-js', "Journal des opérations"),
    bookingServices: Yii.t('wui-shared-js', "Services Afidium"),
    bookingFareOptHistory: Yii.t('wui-shared-js', "Optimisations tarifaires"),
    ancillaryServices: Yii.t('wui-shared-js', "Services annexes"),
    qualityControl: Yii.t('wui-shared-js', "Contrôle qualité"),
    fareOptimisation: Yii.t('wui-shared-js', "Optimisation tarifaire")
};

